(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-plans-fav-meals"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    var slider = tns({
      container: '.collection-plans-fav-meals .slider',
      items: 1,
      mouseDrag: true,
      swipeAngle: false,
      speed: 400,
      controls: false,
      nav: false,
      gutter: 25,
      responsive: {
        576: {
          items: 2
        },
        992: {
          items: 3
        }
      }
    });
    $('.collection-plans-fav-meals .slider-wrapper').css('visibility', 'visible');
    $('.collection-plans-fav-meals .slider-control-previous').on('click', function (event) {
        slider.goTo('prev');
    });
    $('.collection-plans-fav-meals .slider-control-next').on('click', function (event) {
        slider.goTo('next');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-new"]) return;
  try {
    
const navToggle = document.querySelector('header .js-nav-toggle');

navToggle.addEventListener('click', (e) => {
  document.querySelector('header .main-nav').classList.remove('suspend-animation');
  const el = e.currentTarget;
  toggleMenu(el);
});

window.addEventListener('resize', () => {
  const navToggle = document.querySelector('.js-nav-toggle');
  if (navToggle.parentNode.classList.contains('active')) {
    toggleMenu(navToggle);
  };

  // Suspend mobile menu animation on resize
  document.querySelector('header .main-nav').classList.add('suspend-animation');
});

function toggleMenu(el) {
  const body = document.getElementsByTagName('body')[0];
  el.parentNode.classList.toggle('active');
  body.classList.toggle('mobile-nav-lock');
}

let medQuery = window.matchMedia("(max-width: 991.9px)");

$('.main-nav ul a[href="javascript:void(0)"]').on('click', function () {
  const mqMobile = window.matchMedia("(max-width: 991.9px)");
  if (mqMobile.matches) {
    $(this).toggleClass('active');
    $(this).parent('li').find('ul').slideToggle();
  }
});

$('.main-nav ul a').each(function () {
  if ($(this).attr('href') && $(this).attr('href') !== '#' && $(this).attr('href') !== 'javascript:void(0)' && this.hostname !== window.location.hostname) {
    $(this).attr('target', '_blank');
    $(this).attr('rel', 'noopener noreferrer');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	$(document).ready(function () {
		$('.touch-cancel').each(function () {
			$(this).click(function (e) {
				if ('ontouchstart' in window) {
					console.log("Touch Nav");
					e.preventDefault();
					if ($(this).hasClass('touch-active')) {
						console.log("Touch Nav 2");
						window.location = $(this).attr('href');
					}
					$('.touch-cancel').removeClass('touch-active');
					$(this).addClass('touch-active');
				}
			});
		});
	});

  $(document).ready(function () {
      $('.mobile-child').hide();
      $('.has-children').click(function () {
          $(this).next().slideToggle(200);
        	$(this).toggleClass("expanded");
      });
      $('.mobile-child').slideUp(200);
  });

  $(document).ready(function () {
      $('.mobile-nav').hide();
      $('.js-nav-control').click(function () {
   			$(this).closest('header').toggleClass('mheader');
   			$(this).closest('header').find('.mobile-nav').slideToggle(200);
      });
      $('.mobile-nav').slideUp(200);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-affiliate"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {

  	//Set the initial state: highlight the first button...
  	$('.affiliate-menu').find('li:eq(0)').addClass('active');

  	//and hide all tab content except the first one
  	$('.tab-content').find('> div:eq(0)').nextAll().hide();

  	//actions that apply on click of any of the buttons
  	$('.affiliate-menu li').click( function(event) {

  		//turn off the link so it doesn't try to jump down the page
  		event.preventDefault();

  		//un-highlight the buttons
  		$('.affiliate-menu li').removeClass();

  		//hide all the slides
  		$('.tab-content > div').hide();

  		//highlight the current button
  		$(this).addClass('active');

  		//get the index of the current button...
  		var index = $('.affiliate-menu li').index(this);

  		//and use that index to show the corresponding slide
  		$('.tab-content > div:eq('+index+')').show();

  	});

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-how-columns"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    // $('.hidden-block').hide()
    $('.hidden-block').slideUp(200)

    $('.js-how-trigger').click(function () {
      var $this = $(this),
          $element = $this.closest('.page-how-columns').find('.hidden-block')
      $this.toggleClass("expanded")

      if ($this.hasClass('expanded')) {
        $element.slideDown(200)
      } else {
        $element.slideUp(200)
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-media-room-videos"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $('.single-video').click(function () {
      $('.single-video').removeClass('video-selected');
      $(this).addClass('video-selected');
    });

    $('.single-video').click(function () {
      var $url = $(this);
      $('#replaceVideo').attr("src", $url.data('url'));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-video"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    // $('.hidden-block').hide()
    $('.hidden-block').slideUp(200)

    $('.js-how-trigger').click(function () {
      var $this = $(this),
          $element = $this.closest('.page-how-columns').find('.hidden-block')
      $this.toggleClass("expanded")

      if ($this.hasClass('expanded')) {
        $element.slideDown(200)
      } else {
        $element.slideUp(200)
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["program-gf-menu"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    $('.day-filter').on('change', function() {
      var index = $(this).val();

      $('.day-tabs li').removeClass();
      $('.day-tabs').find('li:eq(' + index + ')').addClass('active');
      $(this).addClass('active');
      toggleDay(index);
    });

    $('.day-tabs li').on('click', function(e) {
      e.preventDefault();
      var index = $('.day-tabs li').index(this);

      $('.day-tabs li').removeClass();
      $(this).addClass('active');
      $('.day-filter').val(index);
      toggleDay(index);
    });

    document.querySelectorAll('.menu-slider').forEach(slider => {
      tns({
        container: slider,
        items: 1,
        loop: false,
        controls: false
      });
    });
  });

  function toggleDay(index) {
    var height = $('.day-content').height();
    $('.day-content > .active').fadeOut(300, function () {
      $(this).removeClass('active');
      $('.day-content > div:eq('+index+')').addClass('active').fadeIn(300);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["program-keto-intro"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
      $('.program-keto-intro .more-text').hide();
      $('.program-keto-intro .learn-more-toggle').click(function () {
          $(this).next().slideToggle(200);
        	$(this).toggleClass("expanded");

      });
      $('.program-keto-intro .more-text').slideUp(200);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["program-keto-right"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $('.program-keto-right .more-research').hide();
    $('.program-keto-right .research-toggle').click(function () {
      $(this).next().slideToggle(200);
      $(this).toggleClass("expanded");
    });
    $('.program-keto-right .more-research').slideUp(200);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["program-menu-carousels"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function () {

    var program_slider_settings = {
        //container: '#program-1-slider-wrapper .program-slider',
        items: 1,
        slideBy: 'page',
        mouseDrag: true,
        swipeAngle: false,
        speed: 400,
        controls: false,
        nav: false,
        gutter: 10,
        responsive: {
            576: {
                items: 2
            },
            768: {
                items: 3
            },
            992: {
                items: 4
            }
        }
    }

    var program_1_slider_settings = program_slider_settings;
    program_1_slider_settings.container = '#program-1-slider-wrapper .program-slider';
    var program_1_slider = tns(program_1_slider_settings);
    $('#program-1-slider-wrapper .slider-control-previous').on('click', function (event) {
        program_1_slider.goTo('prev');
    });
    $('#program-1-slider-wrapper .slider-control-next').on('click', function (event) {
        program_1_slider.goTo('next');
    });

    var program_2_slider_settings = program_slider_settings;
    program_2_slider_settings.container = '#program-2-slider-wrapper .program-slider';
    var program_2_slider = tns(program_2_slider_settings);
    $('#program-2-slider-wrapper .slider-control-previous').on('click', function (event) {
        program_2_slider.goTo('prev');
    });
    $('#program-2-slider-wrapper .slider-control-next').on('click', function (event) {
        program_2_slider.goTo('next');
    });

    var program_3_slider_settings = program_slider_settings;
    program_3_slider_settings.container = '#program-3-slider-wrapper .program-slider';
    var program_3_slider = tns(program_3_slider_settings);
    $('#program-3-slider-wrapper .slider-control-previous').on('click', function (event) {
        program_3_slider.goTo('prev');
    });
    $('#program-3-slider-wrapper .slider-control-next').on('click', function (event) {
        program_3_slider.goTo('next');
    });

    var program_4_slider_settings = program_slider_settings;
    program_4_slider_settings.container = '#program-4-slider-wrapper .program-slider';
    var program_4_slider = tns(program_4_slider_settings);
    $('#program-4-slider-wrapper .slider-control-previous').on('click', function (event) {
        program_4_slider.goTo('prev');
    });
    $('#program-4-slider-wrapper .slider-control-next').on('click', function (event) {
        program_4_slider.goTo('next');
    });

    var program_5_slider_settings = program_slider_settings;
    program_5_slider_settings.container = '#program-5-slider-wrapper .program-slider';
    var program_5_slider = tns(program_5_slider_settings);
    $('#program-5-slider-wrapper .slider-control-previous').on('click', function (event) {
        program_5_slider.goTo('prev');
    });
    $('#program-5-slider-wrapper .slider-control-next').on('click', function (event) {
        program_5_slider.goTo('next');
    });

    var program_6_slider_settings = program_slider_settings;
    program_6_slider_settings.container = '#program-6-slider-wrapper .program-slider';
    var program_6_slider = tns(program_6_slider_settings);
    $('#program-6-slider-wrapper .slider-control-previous').on('click', function (event) {
        program_6_slider.goTo('prev');
    });
    $('#program-6-slider-wrapper .slider-control-next').on('click', function (event) {
        program_6_slider.goTo('next');
    });

    var program_7_slider_settings = program_slider_settings;
    program_7_slider_settings.container = '#program-7-slider-wrapper .program-slider';
    var program_7_slider = tns(program_7_slider_settings);
    $('#program-7-slider-wrapper .slider-control-previous').on('click', function (event) {
        program_7_slider.goTo('prev');
    });
    $('#program-7-slider-wrapper .slider-control-next').on('click', function (event) {
        program_7_slider.goTo('next');
    });

    $('.program-slider-selector').on('click', function (event) {
        if ($(this).hasClass('active'))
            return;

        $('.program-slider-selector').removeClass('active');
        $(this).addClass('active');

        $('.program-slider-wrapper').hide();
        var target_slider = $(this).attr("data-id");
        $('#' + target_slider).show();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["program-time-you-save"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $(".ingredient-indicator").click(function () {
      $(".ingredient-indicator").parent().removeClass('selected');
      $(this).parent().addClass('selected');

      var ingredientNumber = $(this).parent().parent().attr("id").substring(11, 12);
      var ingredientDescriptionID = "#ingredient-" + ingredientNumber + "-description";
      $(".ingredient-description").removeClass('selected');
      $(ingredientDescriptionID).addClass('selected');
    });

    $(".ingredient-description").click(function () {
      $(".ingredient-description").removeClass('selected');
      $(this).addClass('selected');

      var ingredientNumber = $(this).attr("id").substring(11, 12);
      var ingredientIndicatorID = "#ingredient-" + ingredientNumber + "-indicator";
      $(".ingredient-indicator").parent().removeClass('selected');
      $(ingredientIndicatorID + " .ingredient-indicator").parent().addClass('selected');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
